<template>
  <div :class="$style.root">
    {{ caption }}
  </div>
</template>

<script setup>
const props = defineProps({
  caption: {
    type: String
  }
})
</script>

<style module>
.root {
  composes: font-size-small from global;

  padding-top: var(--padding--element--top);
  padding-right: var(--unit--default);
  padding-left: var(--unit--default);

  max-width: calc(100% - var(--padding--element--horizontal) - var(--padding--element--horizontal));



  margin-bottom: calc(var(--font-small--font-size) - var(--font-small--line-height));
}
</style>
